export const SORT_BY_QUERY_PARAM_NAME = 'sort_by';
export const SORT_TREE_BY_QUERY_PARAM_NAME = 'sort_tree_by';
export const TAG_FILTER_QUERY_PARAMETER = 'tag';
export const GROUP_VIEW_QUERY_PARAM = 'group_view';
export const PAGE_QUERY_PARAM = 'page';
export const PAGE_SIZE_QUERY_PARAM = 'pageSize';
export const DEVICE_TYPE_QUERY_PARAM = 'deviceType';
export const ASSET_TYPE_QUERY_PARAM = 'assetType';
export const USER_FILTER_QUERY_PARAMETER = 'creationUserId';
export const GROUP_FILTER_QUERY_PARAMETER = 'groupId';

// Add query paramater names here, that should be ignored as filters
export const IGNORE_AS_FILTERS = [
  PAGE_QUERY_PARAM,
  PAGE_SIZE_QUERY_PARAM,
  SORT_TREE_BY_QUERY_PARAM_NAME,
  SORT_BY_QUERY_PARAM_NAME,
  GROUP_VIEW_QUERY_PARAM,
];

// Capturing these would re-open a detail row or re-fire a one-shot toast.
// Duplicated from console/glue constants -- shared cannot import from console.
export const TRANSIENT_QUERY_PARAMS = [
  'github_app_installed',
  'integration_id',
  'issue',
];
